import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

type FormularioLogin = {
  email: string;
  senha: string;
};

@Component({
  selector: 'app-tela-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './tela-login.component.html',
  styleUrls: ['./tela-login.component.css']
})
export class TelaLoginComponent {
  @Input({ required: true }) formulario!: FormularioLogin;
  @Input() logo = '';
  @Input() iniciais = 'PJ';
  @Input() nomeEmpresa = 'Ponto JWM';
  @Input() primeiroAcesso = false;
  @Output() entrar = new EventEmitter<void>();
  @Output() criarPrimeiroAcesso = new EventEmitter<void>();

  senhaVisivel = false;
}
